import React from 'react';
import {useSelector} from 'react-redux';
import {Form} from 'semantic-ui-react';
import {requestsDeviceType} from '../../../../common/constants/lists';
import {Actions} from '../../../../common/actions';
import {parseAgenciesValues} from '../../../../common/util/options';
import {requestsTypeDict} from '../../../constants';
import {parseMotives, parseVehiclesInfo} from '../../../utils';
import Loader from '../../../../common/components/loader';

const {fetchVehiclesInfoBySearch} = Actions;

const DeviceRequestForm = ({action, newRequestDevice, handleChange, dispatch}) => {
  const {agenciesList} = useSelector((state) => state.dealer);
  const {desisntallationMotives, loadingDetail,
    vehicleInfoList, loadingVehicleInfoList} = useSelector((state) => state.requestsDevice);

  const handleSearchChassis = (e, {searchQuery}) => {
    const search = searchQuery.toUpperCase();
    const requestType = newRequestDevice.requestType;
    if (searchQuery.length > 3) {
      dispatch(fetchVehiclesInfoBySearch({requestType, search}));
    }
  };

  if (loadingDetail) {
    return <Loader />;
  }

  return (
    <Form>
      <Form.Group widths='equal'>
        {action === 'see' ? (
          <Form.Input
            fluid
            label='TIPO DE SOLICITUD'
            placeholder='TIPO DE SOLICITUD'
            name='requestType'
            readOnly
            value={requestsTypeDict[newRequestDevice.requestType]}
          ></Form.Input>
        ) : (
          <Form.Dropdown
            selection
            fluid
            options={requestsDeviceType}
            label='TIPO DE SOLICITUD'
            placeholder='TIPO DE SOLICITUD'
            name='requestType'
            required
            error={!newRequestDevice.requestType}
            value={newRequestDevice.requestType}
            onChange={handleChange}
          ></Form.Dropdown>
        )}
        {newRequestDevice.requestType === 'D' &&
          (action === 'see' ? (
            <Form.Input
              fluid
              label='MOTIVO'
              placeholder='MOTIVO'
              name='motiveCode'
              readOnly
              value={newRequestDevice.motiveCode}
            ></Form.Input>
          ) : (
            <Form.Dropdown
              fluid
              selection
              label='MOTIVO'
              placeholder='MOTIVO'
              name='motiveCode'
              required
              options={parseMotives(desisntallationMotives)}
              disabled={!newRequestDevice.requestType}
              value={newRequestDevice.motiveCode}
              onChange={handleChange}
            ></Form.Dropdown>
          ))}
        {action === 'see' ? (
          <Form.Input
            fluid
            label='AGENCIA'
            placeholder='AGENCIA'
            name='agency'
            readOnly
            value={newRequestDevice.agency}
          ></Form.Input>
        ) : (
          <Form.Dropdown
            selection
            fluid
            label='AGENCIA'
            placeholder='AGENCIA'
            name='agency'
            required
            options={parseAgenciesValues(agenciesList)}
            disabled={!newRequestDevice.requestType}
            value={newRequestDevice.agency}
            onChange={handleChange}
          ></Form.Dropdown>
        )}
      </Form.Group>
      <Form.Group widths='equal'>
        {action === 'see' ? (
          <Form.Input
            fluid
            label='CHASIS'
            placeholder='CHASIS'
            name='chassis'
            readOnly
            value={newRequestDevice.chassis}
          ></Form.Input>
        ) : (
          <Form.Dropdown
            search
            selection
            fluid
            label='CHASIS'
            placeholder='CHASIS'
            name='chassis'
            required
            disabled={!newRequestDevice.requestType || loadingVehicleInfoList}
            value={newRequestDevice.chassis}
            options={parseVehiclesInfo(vehicleInfoList)}
            loading={loadingVehicleInfoList}
            onChange={handleChange}
            onSearchChange={handleSearchChassis}
            noResultsMessage='No se encontro resultados'
          ></Form.Dropdown>
        )}
        <Form.Input
          fluid
          label='KATASHIKI'
          placeholder='KATASHIKI'
          name='katashiki'
          readOnly
          value={newRequestDevice.katashiki}
        ></Form.Input>
        <Form.Input
          fluid
          label='MODELO'
          placeholder='MODELO'
          name='model'
          readOnly
          value={newRequestDevice.model}
        ></Form.Input>
      </Form.Group>
      <Form.Group widths='equal'>
        <Form.Input
          fluid
          label='NOMBRE CLIENTE'
          placeholder='NOMBRE CLIENTE'
          name='clientName'
          required
          readOnly={action === 'see'}
          disabled={!newRequestDevice.requestType}
          value={newRequestDevice.clientName}
          onChange={handleChange}
        ></Form.Input>
        <Form.Input
          fluid
          label='CÉDULA CLIENTE'
          placeholder='CÉDULA CLIENTE'
          name='clientId'
          required
          readOnly={action === 'see'}
          disabled={!newRequestDevice.requestType}
          value={newRequestDevice.clientId}
          onChange={handleChange}
        ></Form.Input>
        <Form.Input
          fluid
          label='CELULAR'
          placeholder='CELULAR'
          name='phone'
          required
          readOnly={action === 'see'}
          disabled={!newRequestDevice.requestType}
          value={newRequestDevice.phone}
          onChange={handleChange}
        ></Form.Input>
      </Form.Group>
      <Form.Group widths='equal'>
        <Form.Input
          fluid
          label='NOMBRE VENDEDOR'
          placeholder='NOMBRE VENDEDOR'
          name='sellerName'
          required
          readOnly={action === 'see'}
          disabled={!newRequestDevice.requestType}
          value={newRequestDevice.sellerName}
          onChange={handleChange}
        ></Form.Input>
      </Form.Group>
      <Form.Group widths='equal'>
        <Form.Input
          fluid
          label='OBSERVACIONES'
          placeholder='OBSERVACIONES'
          name='observations'
          maxLength={200}
          readOnly={action === 'see'}
          disabled={!newRequestDevice.requestType}
          value={newRequestDevice.observations}
          onChange={handleChange}
        ></Form.Input>
      </Form.Group>
    </Form>
  );
};

export default DeviceRequestForm;
